import React from 'react';
import { motion } from 'framer-motion';
const valueItems = [{
  icon: '📗',
  name: 'Tomo 1: Masa Perfecta',
  price: '$197'
}, {
  icon: '📘',
  name: 'Tomo 2: 50 Recetas',
  price: '$197'
}, {
  icon: '🧮',
  name: 'Calculadora Pro',
  price: '$97'
}, {
  icon: '🧀',
  name: 'Bordes Rellenos',
  price: '$47'
}, {
  icon: '🌾',
  name: 'Masa Madre',
  price: '$37'
}, {
  icon: '🍅',
  name: 'Salsas Secretas',
  price: '$27'
}, {
  icon: '🫓',
  name: 'Focaccias y Panes',
  price: '$17'
}];
export function PricingSection() {
  return <div className="bg-[#111111] border-t border-b border-[#C0392B]/20 py-6 px-5" id="precio" data-id="element-92">
      <div className="max-w-3xl mx-auto" data-id="element-93">
        {/* Value Stack + Price combined */}
        <motion.div className="bg-gradient-to-br from-[#1A0000] to-[#0D0D0D] border-4 border-[#C0392B] rounded-2xl p-5 sm:p-8 text-center relative overflow-hidden" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-94">
          <div className="absolute text-[150px] opacity-[0.03] -top-5 -right-5" data-id="element-95">
            🍕
          </div>

          <p className="text-[#F1C40F] text-xs tracking-[3px] uppercase mb-3" data-id="element-96">
            ⚡ Precio Especial de Lanzamiento ⚡
          </p>

          {/* Compact value stack */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-4 text-[10px]" data-id="element-97">
            {valueItems.map((item, i) => <div key={i} className="bg-black/30 rounded px-2 py-1.5 flex items-center gap-1.5" data-id="element-98">
                <span data-id="element-99">{item.icon}</span>
                <span className="text-[#F5F5F5] flex-1 truncate" data-id="element-100">
                  {item.name}
                </span>
                <span className="text-[#27AE60] font-bold" data-id="element-101">{item.price}</span>
              </div>)}
          </div>

          <div className="flex items-center justify-center gap-3 mb-3" data-id="element-102">
            <span className="text-[#666] text-lg line-through" data-id="element-103">$619 USD</span>
            <span className="text-[#F5F5F5] text-lg" data-id="element-104">→</span>
          </div>

          <div className="text-5xl sm:text-6xl md:text-7xl text-[#F1C40F] font-bold leading-none mb-1" style={{
          textShadow: '0 0 40px rgba(241,196,15,0.4)'
        }} data-id="element-105">
            <span className="text-2xl align-super text-[#C0392B]" data-id="element-106">$</span>19.999
          </div>

          <p className="text-[#AAAAAA] text-xs mb-4 italic" data-id="element-107">
            Pago único · Sin suscripciones · Acceso de por vida
          </p>

          <motion.a href="https://pagos.indigo33.shop/cart/44020376993880:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-to-br from-[#C0392B] to-[#922B21] text-[#F1C40F] px-8 py-3 rounded-md text-base font-bold uppercase tracking-wider border-2 border-[#F1C40F] cursor-pointer" whileHover={{
          y: -3,
          scale: 1.02
        }} animate={{
          boxShadow: ['0 8px 30px rgba(192,57,43,0.5)', '0 8px 50px rgba(192,57,43,0.9)', '0 8px 30px rgba(192,57,43,0.5)']
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} data-id="element-108">
            ✅ SÍ, QUIERO ACCESO AHORA
          </motion.a>
          <span className="block text-[10px] text-[#F5F5F5] mt-1.5 opacity-80" data-id="element-109">
            🔒 Pago Seguro · 📲 Acceso Inmediato · 🍕 Descarga Digital
          </span>

          {/* Guarantee merged */}
          <div className="mt-4 pt-3 border-t border-[#27AE60]/20 flex items-center justify-center gap-2" data-id="element-110">
            <span className="text-2xl" data-id="element-111">🛡️</span>
            <p className="text-[#27AE60] text-[10px] sm:text-xs font-bold" data-id="element-112">
              GARANTÍA TOTAL — Si tu pizza no mejora, te devolvemos el 100% sin
              preguntas.
            </p>
          </div>
        </motion.div>
      </div>
    </div>;
}